import React, { PureComponent } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { formatMoney } from '../../../util/utils'

class BudgetRow extends PureComponent {
  render () {
    const {
      tKey,
      t,
      budget: { dossierBudgetRatingId, ratingItem, freeRating, amount },
      fetchDossierBudgetRating,
      deleteDossierBudgetRating,
      readOnlyFields
    } = this.props
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT_BTN`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE_BTN`)}</Tooltip>)
    return (
      <tr>
        <td>{ratingItem || freeRating}</td>
        <td className="text-left">{ amount ? formatMoney(amount) : formatMoney(0)} </td>
        { !readOnlyFields
          ? <td className='actions'>
            <div className='content'>
              <OverlayTrigger placement="left" overlay={editTooltip}>
                <a className="_Btn accept stk o-icn noLine" onClick={() => fetchDossierBudgetRating(dossierBudgetRatingId)}>
                  <i className="iDocIcon-edit"/>
                </a>
              </OverlayTrigger>
              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                <a className="_Btn cancel stk o-icn noLine" onClick={() => deleteDossierBudgetRating(dossierBudgetRatingId)}>
                  <i className="iDocIcon-delete-forever"/>
                </a>
              </OverlayTrigger>
            </div>
          </td> : <td/>
        }
      </tr>
    )
  }
}
export default BudgetRow
